const Footer = () => {
    return (
      <footer className="bg-gray-900 text-white py-10">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            {/* TX Hospitals Section (wider column) */}
            <div className="md:col-span-2">
              <h3 className="text-xl font-semibold mb-4 relative">
                TX Hospitals
                <span className="absolute left-0 bottom-[-4px] h-[1px] w-16 bg-red-600"></span>
              </h3>
              <p className="text-sm text-gray-300 mb-4">
                TX Hospitals Group is one of the country's largest and fastest-growing chains of multi-super specialty hospitals. We have opened six healthcare facilities (including projects under development) in two years since opening our first hospital in Hyderabad in 2020.
              </p>
              <h4 className="text-lg font-semibold mb-2 relative">
                Contact Us
                <span className="absolute left-0 bottom-[-4px] h-[1px] w-12 bg-red-600"></span>
              </h4>
              <p className="text-sm text-gray-300 hover:text-red-600 cursor-pointer">Email - contact@txhospitals.in</p>
              <p className="text-sm text-gray-300 hover:text-red-600 cursor-pointer">Uppal : 040-43108108</p>
              <p className="text-sm text-gray-300 hover:text-red-600 cursor-pointer">Kachiguda : 040-48108108</p>
              <p className="text-sm text-gray-300 hover:text-red-600 cursor-pointer">Banjara Hills : 040-66529999</p>
              <h4 className="text-lg font-semibold mt-4 mb-2 relative">
                Follow us
                <span className="absolute left-0 bottom-[-4px] h-[1px] w-12 bg-red-600"></span>
              </h4>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/txhospitals/" aria-label="Facebook" className="text-gray-400 hover:text-red-600 cursor-pointer">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://www.linkedin.com/company/tx-hospitals/" aria-label="LinkedIn" className="text-gray-400 hover:text-red-600 cursor-pointer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="https://twitter.com/txhospitals" aria-label="Twitter" className="text-gray-400 hover:text-red-600 cursor-pointer">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="https://www.youtube.com/channel/UCuHZd4Yi3wTHciJoMz7mq2A" aria-label="YouTube" className="text-gray-400 hover:text-red-600 cursor-pointer">
                  <i className="fab fa-youtube"></i>
                </a>
                <a href="https://www.instagram.com/txhospitals/" aria-label="Instagram" className="text-gray-400 hover:text-red-600 cursor-pointer">
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>
  
            {/* Centre of Excellence Section */}
            <div>
              <h3 className="text-xl font-semibold mb-4 relative">
                Centre of Excellence
                <span className="absolute left-0 bottom-[-4px] h-[1px] w-20 bg-red-600"></span>
              </h3>
              <ul className="text-sm text-gray-300 space-y-2">
                <li className="hover:text-red-600 cursor-pointer">Cardiac Sciences</li>
                <li className="hover:text-red-600 cursor-pointer">Neuro Sciences</li>
                <li className="hover:text-red-600 cursor-pointer">Renal Sciences</li>
                <li className="hover:text-red-600 cursor-pointer">Gastro Sciences</li>
                <li className="hover:text-red-600 cursor-pointer">Oncology</li>
                <li className="hover:text-red-600 cursor-pointer">Orthopaedics & Rheumatology</li>
                <li className="hover:text-red-600 cursor-pointer">Internal Medicine</li>
                <li className="hover:text-red-600 cursor-pointer">Mother & Child Care</li>
                <li className="hover:text-red-600 cursor-pointer">Anesthesia & Pain Management</li>
                <li className="hover:text-red-600 cursor-pointer">Dermatology & Cosmetic Care</li>
                <li className="hover:text-red-600 cursor-pointer">Eye / Ophthalmology</li>
                <li className="hover:text-red-600 cursor-pointer">Dental & Maxillofacial</li>
                <li className="hover:text-red-600 cursor-pointer">Endocrinology</li>
                <li className="hover:text-red-600 cursor-pointer">Transplant Medicine</li>
                <li className="hover:text-red-600 cursor-pointer">Wellness & Diagnostic Centre</li>
                <li className="hover:text-red-600 cursor-pointer">Robotic Sciences</li>
                <li className="hover:text-red-600 cursor-pointer">Pulmonology</li>
              </ul>
            </div>
  
            {/* Patients & Visitors Section */}
            <div>
              <h3 className="text-xl font-semibold mb-4 relative">
                Patients & Visitors
                <span className="absolute left-0 bottom-[-4px] h-[1px] w-20 bg-red-600"></span>
              </h3>
              <ul className="text-sm text-gray-300 space-y-2">
                <li className="hover:text-red-600 cursor-pointer">Patient's Guidelines</li>
                <li className="hover:text-red-600 cursor-pointer">Visitor's Guidelines</li>
                <li className="hover:text-red-600 cursor-pointer">In-Patient</li>
                <li className="hover:text-red-600 cursor-pointer">Rooms Facilities & Services</li>
                <li className="hover:text-red-600 cursor-pointer">Insurance</li>
                <li className="hover:text-red-600 cursor-pointer">International Patients</li>
                <li className="hover:text-red-600 cursor-pointer">Privilege Card</li>
              </ul>
              <h3 className="text-xl font-semibold mt-6 mb-4 relative">
                Facilities
                <span className="absolute left-0 bottom-[-4px] h-[1px] w-16 bg-red-600"></span>
              </h3>
              <ul className="text-sm text-gray-300 space-y-2">
                <li className="hover:text-red-600 cursor-pointer">Facilities & Services</li>
                <li className="hover:text-red-600 cursor-pointer">Diagnostic & Therapeutic</li>
                <li className="hover:text-red-600 cursor-pointer">Pharmacy</li>
              </ul>
            </div>
  
            {/* Quick Links Section */}
            <div>
              <h3 className="text-xl font-semibold mb-4 relative">
                Quick Links
                <span className="absolute left-0 bottom-[-4px] h-[1px] w-16 bg-red-600"></span>
              </h3>
              <ul className="text-sm text-gray-300 space-y-2">
                <li className="hover:text-red-600 cursor-pointer">About TX Hospitals</li>
                <li className="hover:text-red-600 cursor-pointer">Board Of Directors</li>
                <li className="hover:text-red-600 cursor-pointer">Management</li>
                <li className="hover:text-red-600 cursor-pointer">Why TX?</li>
                <li className="hover:text-red-600 cursor-pointer">Academics</li>
                <li className="hover:text-red-600 cursor-pointer">Blogs</li>
                <li className="hover:text-red-600 cursor-pointer">Careers</li>
                <li className="hover:text-red-600 cursor-pointer">Doctors</li>
                <li className="hover:text-red-600 cursor-pointer">Biomedical Wastage</li>
                <li className="hover:text-red-600 cursor-pointer">News & Media</li>
                <li className="hover:text-red-600 cursor-pointer">Health Packages</li>
                <li className="hover:text-red-600 cursor-pointer">MRI Scan</li>
                <li className="hover:text-red-600 cursor-pointer">Hospital Brochure</li>
                <li className="hover:text-red-600 cursor-pointer">Contact Us</li>
                <li className="hover:text-red-600 cursor-pointer">Privacy Policy</li>
                <li className="hover:text-red-600 cursor-pointer">Disclaimer</li>
              </ul>
            </div>
          </div>
          {/* Footer Bottom Section */}
          <div className="text-center text-gray-400 mt-10 text-sm">
            © {new Date().getFullYear()} TX Hospitals. All rights reserved.
          </div>
        </div>
      </footer>
    );
  };
  
  export default Footer;
  